module.exports = __webpack_public_path__ + "static/media/change-password.2b21cc55.svg";